<template>
  <div>
    <a href="javascript:" class="btn btn-unidade text-nowrap" @click="selUnidade()" v-if="!home">
      Unidade <i class="fa fa-angle-down text-primary ml-1"></i>
    </a>
    <div class="container-fluid bg-white border-bottom shadow-sm py-1 px-3 text-center" v-else>
      <a href="javascript:" class="btn btn-sm font-weight-bolder" @click="selUnidade()">
        Alterar Unidade <i class="fa fa-angle-down text-primary ml-1"></i>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CardFranquia",
    props: ['home'],
    methods: {
      selUnidade() {
        localStorage.removeItem('domain_default');
        sessionStorage.removeItem('cuponsReadonly');
        this.$router.push('/');
      }
    },
    computed: {
      empresa() {
        return this.$store.state.empresa
      }
    }
  }
</script>
<style scoped>
.btn-unidade {
  font-size: 0.85em;
  font-weight: bold;
  border: 1px solid var(--lecard-primary);
  color: var(--dark);
}

.btn-unidade:hover {
  color: var(--lecard-primary);
}

@media (min-width: 768px) {
  .btn-unidade {
    border: none;
    font-size: 0.9em;
    font-weight: normal;
    padding: 10px 10px 6px;
  }
}
</style>